export const prospectStatus = () => [
  { value: 0, key: 'not_contacted', label: 'Not Contacted', color: 'dark-grey' },
  { value: 1, key: 'attempted_contact', label: 'Attempted Contact', color: 'mustard' },
  { value: 2, key: 'contacted', label: 'Contacted', color: 'green' },
  { value: 4, key: 'archived', label: 'Archived', color: 'red' },
];
